import { useMemo } from 'react';
import { usePageOfAvailableRateTableDimensions } from '~/modules/rateCard/advancedRateCard/components/hooks/usePageOfAvailableRateTableDimensions';
import { INCLUDE_DIMENSION_SLUGS, OVERRIDE_DIMENSION_PROPS } from './enum';

const REQUIRED_SLUGS = [];

export const useAvailableCostOverrideDimensions = ({
  selectedDimensions = []
} = {}) => {
  const {
    availableRateTableDimensions
  } = usePageOfAvailableRateTableDimensions({
    includeSlugs: INCLUDE_DIMENSION_SLUGS,
    overrideProps: OVERRIDE_DIMENSION_PROPS,
    requiredSlugs: REQUIRED_SLUGS
  });

  const availableDimensions = useMemo(() => {
    const selectedIds = new Set(selectedDimensions.map(d => d.id));
    const selectedObjectTypes = new Set(
      selectedDimensions.map(d => d.objectType)
    );

    return availableRateTableDimensions.filter(
      d => !selectedIds.has(d.id) && !selectedObjectTypes.has(d.objectType)
    );
  }, [availableRateTableDimensions, selectedDimensions]);

  return { availableDimensions };
};

export default useAvailableCostOverrideDimensions;
